import { array, object, string } from 'yup'
import { t } from 'ttag'

import {
  COMPETENCIES_FIELD,
  TEMPLATE_LANGUAGE_FIELD,
  TEMPLATE_NAME_FIELD,
  DEPARTMENT_FIELD,
} from './model'

export const TEMPLATE_NAME_LIMIT = 100

export const getSchema = () =>
  object().shape({
    [TEMPLATE_NAME_FIELD]: string()
      .max(TEMPLATE_NAME_LIMIT, t`Template name cannot exceed 100 characters.`)
      .required(t`This field cannot be empty.`),
    [TEMPLATE_LANGUAGE_FIELD]: object()
      .shape({ label: string(), value: string() })
      .required(t`This field cannot be empty.`),
    [COMPETENCIES_FIELD]: array().of(
      object().shape({
        name: string(),
      }),
    ),
    [DEPARTMENT_FIELD]: object()
      .shape({ label: string(), value: string() })
      .required(t`This field cannot be empty.`),
  })

export const getEditCompetenciesSchema = () =>
  object().shape({
    [COMPETENCIES_FIELD]: array().of(
      object().shape({
        name: string(),
      }),
    ),
  })
